import {CLCTaEnvironment} from '../app/app.config';

/**
 * Runtime configuration injected via config.js at container startup.
 * The FRONTEND_CONFIG environment variable is written to assets/config.js
 * by the Docker entrypoint script, setting window.__APP_CONFIG__.
 */
interface AppConfig {
  baseUrl: string;
  baseServerUrl: string;
  scopeUri: string;
  tenantId: string;
  uiClientId: string;
  redirectUrl: string;
  authority: string;
}

const config: AppConfig = (window as any).__APP_CONFIG__;

if (!config) {
  throw new Error('Runtime configuration not found. Ensure config.js is loaded before the application.');
}

export const environment: CLCTaEnvironment = {
  appName: 'CLC Travel Allowance',
  appVersion: '0',
  tenantSettings: {
    name: 'CLC',
    baseUrl: config.baseUrl,
    baseServerUrl: config.baseServerUrl,
    scopeUris: [config.scopeUri],
    tenantId: config.tenantId,
    uiClientId: config.uiClientId,
    redirectUrl: config.redirectUrl,
    authority: config.authority,
  }
};
